import Settings from '../settings';

const baseUrl = `${Settings.streamServer}:9001/json/instances/top_left/playhead`;

const handleStreamResponse = (response) => new Promise((resolve) => {
  if (response.ok) {
    return resolve(response.json());
  }
  throw (new Error('Response not ok.'));
}).then(data => {
  if (data.statusCode === 500) {
    console.log(data);
    throw (new Error('Unexpected error getting data from stream server.  Bad JSON received.'));
  }
  return Promise.resolve(data);
});

export const openVideo = (filePath) => {
  const serverFilePath = filePath.replace(/\\/g, '/');
  const url = `${baseUrl}/open/${serverFilePath}`;
  return fetch(url)
    .then(handleStreamResponse)
    .catch(error => console.log(`Failed to open video on stream server. Error: ${error}`));
};

export const getVideoDuration = () => fetch(`${baseUrl}/position`)
  .then(handleStreamResponse)
  .catch(error => console.log(`Failed to get video duration from stream server. Error: ${error}`));

export const playVideo = () => fetch(`${baseUrl}/state/play`)
  .then(handleStreamResponse)
  .catch(error => console.log(`Failed to play video on stream server. Error: ${error}`));

export const pauseVideo = () => fetch(`${baseUrl}/state/stop`)
  .then(handleStreamResponse)
  .catch(error => console.log(`Failed to pause video on stream server. Error: ${error}`));

export const setPosition = (position) => fetch(`${baseUrl}/position/${position}/1000`)
  .then(handleStreamResponse)
  .catch(error => console.log(`Failed to set position of video on stream server. Error: ${error}`));



// WEBPACK FOOTER //
// ./app/api/clipperStream.js